import { TeamsAdministrationChannelPage } from '@features/portal-tools/sub-features/teams-administration/components/TeamsAdministrationChannelPage'
import { teamsAdministrationChannelQueryOptions } from '@features/portal-tools/sub-features/teams-administration/queries'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/tools/teams-administration/teams/$teamId/channels/$channelId')({
    component: RouteComponent,
    loader: ({ params, context }) =>
        context.queryClient.ensureQueryData(teamsAdministrationChannelQueryOptions(params.teamId, params.channelId)),
    staticData: {
        crumb: {
            label: (match) => match.loaderData?.displayName ?? match.params.channelId
        }
    }
})

function RouteComponent() {

    const { teamId, channelId } = Route.useParams()

    return (
        <TeamsAdministrationChannelPage teamId={teamId} channelId={channelId} />
    )
}
